import { FILE_EXPORT_FORMAT_CATALOG } from "@/object-actions/fileRecordExportCatalog";
import { trackActionInvoked } from "@/object-actions/trackObjectAction";
import type {
  ObjectActionVariant,
  ResolvedObjectAction,
} from "@/object-actions/types";
import { trackFileDownloaded } from "@/utils/analytics";

export interface TextNoteDownloadParams {
  exportMarkdown: () => void;
  exportWord: () => void;
}

/**
 * Expands the registry `download` action on a text note into its format
 * variants (Markdown / Word), rendered as the same nested format submenu
 * file records get (see {@link attachFileRecordDownloadVariants}).
 */
export function attachTextNoteDownloadVariants(
  actions: ResolvedObjectAction[],
  params: TextNoteDownloadParams,
): ResolvedObjectAction[] {
  return actions.map((action) => {
    if (action.id !== "download") {
      return action;
    }

    const trackedExport =
      (format: "markdown" | "docx", extension: string, run: () => void) =>
      () => {
        trackActionInvoked("download", {
          objectKind: "canvas-node",
          objectSubtype: "text-note",
          format,
        });
        trackFileDownloaded({ format, extension });
        run();
      };

    const variants: ObjectActionVariant[] = [
      {
        id: "download:markdown",
        label: FILE_EXPORT_FORMAT_CATALOG.markdown.label,
        handler: trackedExport("markdown", "md", params.exportMarkdown),
      },
      {
        id: "download:docx",
        label: FILE_EXPORT_FORMAT_CATALOG.docx.label,
        handler: trackedExport("docx", "docx", params.exportWord),
      },
    ];

    return { ...action, variants, handler: () => {} };
  });
}
